/**
 * Marqueeブロックのフロントエンド用JavaScript
 * 画像を複製してマーキー効果を実装
 */

(function () {
  "use strict";

  /**
   * 画像を画面幅の2倍になるまで複製する
   *
   * @param {HTMLElement} container - コンテナ要素
   * @param {string} imageUrl - 画像URL
   * @param {number} imageWidth - 画像幅
   * @param {number} imageHeight - 画像高さ
   * @param {string} alt - alt属性
   */
  function duplicateImages(
    container,
    imageUrl,
    imageWidth,
    imageHeight,
    alt,
    speed,
  ) {
    if (!container || !imageUrl) return;

    // 既存の画像をクリア
    container.innerHTML = "";

    // 画像が読み込まれた後に複製処理を実行
    const tempImg = new Image();
    tempImg.onload = function () {
      // 画面幅を取得
      const viewportWidth = window.innerWidth;
      const targetWidth = viewportWidth * 2;

      // 実際の画像幅を使用（指定がない場合は画像の自然な幅）
      const actualImageWidth =
        imageWidth || tempImg.naturalWidth || tempImg.width;
      const actualImageHeight =
        imageHeight || tempImg.naturalHeight || tempImg.height;

      // 必要な画像数を計算（画面幅の2倍をカバーするため）
      // アニメーションがスムーズにループするように、2セット分の画像を用意
      const imageCount = Math.ceil(targetWidth / actualImageWidth) + 1;

      // 画像を複製（2セット分）
      for (let i = 0; i < imageCount; i++) {
        const img = document.createElement("img");
        img.src = imageUrl;
        img.width = actualImageWidth / 2;
        img.height = actualImageHeight / 2;
        img.alt = alt || "";
        img.style.display = "block";
        img.style.flexShrink = "0";
        img.style.animationDuration = `${speed}s`;
        container.appendChild(img);
      }
    };
    tempImg.src = imageUrl;
  }

  /**
   * マーキー効果を初期化
   */
  function initMarquee() {
    const marquees = document.querySelectorAll(".marquee");

    marquees.forEach(function (marquee) {
      const imageUrl = marquee.getAttribute("data-image-url");
      const imageWidth = parseInt(marquee.getAttribute("data-image-width"), 10);
      const imageHeight = parseInt(
        marquee.getAttribute("data-image-height"),
        10,
      );
      const alt = marquee.getAttribute("data-alt") || "";
      const speed = parseInt(marquee.getAttribute("data-speed"), 10);
      if (imageUrl) {
        duplicateImages(marquee, imageUrl, imageWidth, imageHeight, alt, speed);

        // リサイズ時に再計算
        let resizeTimer;
        window.addEventListener("resize", function () {
          clearTimeout(resizeTimer);
          resizeTimer = setTimeout(function () {
            duplicateImages(
              marquee,
              imageUrl,
              imageWidth,
              imageHeight,
              alt,
              speed,
            );
          }, 250);
        });
      }
    });
  }

  // DOMContentLoaded時に初期化
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initMarquee);
  } else {
    initMarquee();
  }
})();
